(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/preview/components/gift-info.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/preview/components/gift-info.js');
"use strict";


const {
  EMAIL,
  PHONE
} = svs.tickets_giftshop.constants.names;
const GiftInfo = _ref => {
  let {
    email,
    phone,
    receiverType,
    dateString,
    totalProducts,
    totalProductSum
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "tg-preview-info-container"
  }, React.createElement("div", {
    className: "tg-preview-info f-content"
  }, React.createElement("div", {
    className: "tg-preview-info-left"
  }, React.createElement("div", null, "".concat(totalProducts > 1 ? 'Lotterna' : 'Lotten'), " skickas till:"), React.createElement("div", null, "".concat(totalProducts > 1 ? 'Lotterna' : 'Lotten'), " skickas:"), React.createElement("div", null, "Antal lotter:"), React.createElement("div", null, "Pris:")), React.createElement("div", {
    className: "tg-preview-info-right"
  }, React.createElement("div", {
    className: "tg-truncate-field data-hj-suppress"
  }, receiverType === EMAIL ? email : phone), React.createElement("div", null, dateString), React.createElement("div", null, "".concat(totalProducts || 0, " st")), React.createElement("div", null, "".concat(totalProductSum || 0, " kr"))))));
};
svs.tickets_giftshop.preview.components.GiftInfo = GiftInfo;

 })(window);